import gql from "graphql-tag";

// Query
export const GET_USER = gql`
  query user($customer_id: String!) {
    user(customer_id: $customer_id) {
      id
      customer_id
      buyer_id
      name
      email
      cpf
      group
      payment_type
      card_default
      payment_type
      partner_id
      power_plants {
        power_plant_id
        name
      }
      send_proposal
      referral_id
      signedcontract_at
      status
    }
  }
`;

// Query
export const GET_USER_DETAIL = gql`
  query user($customer_id: String!) {
    user(customer_id: $customer_id) {
      id
      customer_id
      buyer_id
      name
      email
      cpf
      date_of_birth
      group
      ID_document
      last_invoice
      marital_status
      marital_type
      nationality
      payment_type
      phone
      gender
      profession
      requiredPSChange
      partner_id
      address {
        address
        address_number
        address_complement
        district
        postal_code
        state {
          name
          initials
        }
        city
        country {
          name
          initials
        }
      }
      lead {
        average_consumption
        promo_code
      }
      consumerunits {
        id
        customer_number
        installation_number
        percentage
        power_plant_id
        initial_average_comsumption
      }
      created_at
      updated_at
      signedcontract_at
      card_default
      payment_type
      power_plants {
        power_plant_id
        name
      }
      referral_id
      status
      installation_number
      installation_numbers {
        color
        text
      }
    }
  }
`;

export const GET_USERBYEMAIL = gql`
  query userByEmail($email: String!) {
    userByEmail(email: $email) {
      id
      customer_id
      name
      email
      status
      group
      referral_balance
      referral_indicator
      referral_balance_future
      referral_reward
      referral_id
      signedcontract_at
    }
  }
`;

// Query
export const GET_USERS = gql`
  query users($orderBy: UserOrderByInput) {
    users(orderBy: $orderBy) {
      updated_at
      created_at
      customer_id
      buyer_id
      name
      email
      phone
      cpf
      group
      payment_type
      card_default
      status
      signedcontract_at
      lead {
        name
      }
    }
  }
`;

// Mutations
export const SET_USER = gql`
  mutation createCard(
    $card_number: String!
    $card_expiration_date: String!
    $card_holder_name: String!
    $card_cvv: String!
    $customer_id: String!
    $card_hash: String
    $card_default: Boolean!
    $external_id: String!
  ) {
    createCard(
      card: {
        card_number: $card_number
        card_expiration_date: $card_expiration_date
        card_holder_name: $card_holder_name
        card_cvv: $card_cvv
        customer_id: $customer_id
        card_hash: $card_hash
        card_default: $card_default
        external_id: $external_id
      }
    ) {
      id
      brand
      holder_name
      first_digits
      last_digits
      valid
      expiration_date
    }
  }
`;

// Mutations
export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $name: String!
    $email: String!
    $status: StatusEnum!
    $group: String!
    $referral_indicator: Int!
    $referral_balance: Int!
    $referral_reward: Int!
    $doneBy: String
    $change: String
  ) {
    updateUser(
      user: {
        id: $id
        name: $name
        email: $email
        status: $status
        group: $group
        referral_indicator: $referral_indicator
        referral_balance: $referral_balance
        referral_reward: $referral_reward
        doneBy: $doneBy
        change: $change
      }
    ) {
      id
    }
  }
`;

// Mutations
export const STORE_USER = gql`
  mutation storeUserComplete(
    $email: String!
    $name: String!
    $cpf: String
    $phone: String
    $group: String!
    $ID_document: String
    $status: StatusEnum!
    $payment_type: String
    $date_of_birth: Date
    $gender: String
    $marital_status: String
    $marital_type: String
    $nationality: String
    $profession: String
    $address: InputAddress
    $doneBy: String
    $change: String
  ) {
    storeUserComplete(
      user: {
        email: $email
        name: $name
        cpf: $cpf
        phone: $phone
        group: $group
        ID_document: $ID_document
        status: $status
        payment_type: $payment_type
        date_of_birth: $date_of_birth
        gender: $gender
        marital_status: $marital_status
        marital_type: $marital_type
        nationality: $nationality
        profession: $profession
        address: $address
        doneBy: $doneBy
        change: $change
      }
    ) {
      id
      buyer_id
      customer_id
    }
  }
`;
